import { render, staticRenderFns } from "./order_split_record.vue?vue&type=template&id=44f3ecb0&scoped=true&"
import script from "./order_split_record.vue?vue&type=script&lang=js&"
export * from "./order_split_record.vue?vue&type=script&lang=js&"
import style0 from "./order_split_record.vue?vue&type=style&index=0&id=44f3ecb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f3ecb0",
  null
  
)

export default component.exports